import { Component } from 'react';
import PropTypes from 'prop-types';
import css from './banner.module.scss';

class Banner extends Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    className: PropTypes.string,
  };

  state = {
    imageLoadFailed: false,
  };

  onImageLoadError = () => {
    this.setState({ imageLoadFailed: true });
  };

  render() {
    if (this.state.imageLoadFailed) {
      return null;
    }

    const { src, title, className } = this.props;

    return (
      <section className="row">
        <div className={className}>
          <div className={css.bannerWrapper}>
            <img
              src={src}
              alt={title}
              className={css.banner}
              data-testid="profileBanner"
              onError={this.onImageLoadError}
            />
          </div>
        </div>
      </section>
    );
  }
}

export default Banner;
